import { useMemo } from 'react';

import { createApolloClient } from './createApolloClient';

import type { NormalizedCacheObject } from '@apollo/client';
import type { ApolloClient } from './createApolloClient';

export function useApollo(initialState?: NormalizedCacheObject): ApolloClient {
  return useMemo(() => createApolloClient({ initialState }), [initialState]);
}
